import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/* Local, self-contained theme helpers (Admin-only toggle) */
const THEME_KEY = "app.theme";
function readTheme() {
  const attr = document.documentElement.getAttribute("data-theme");
  if (attr === "dark" || attr === "light") return attr;
  const saved = localStorage.getItem(THEME_KEY);
  return saved === "dark" ? "dark" : "light";
}
function applyTheme(theme) {
  const t = theme === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", t);
  localStorage.setItem(THEME_KEY, t);
}

export default function AdminPage() {
  const navigate = useNavigate();
  const [theme, setTheme] = useState(() => readTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  return (
    <div className="container ak-admin-page">
      {/* Top spacing under the navbar (reliable even if header is sticky/fixed) */}
      <style>{`
        .ak-admin-page{
          padding-top: 26px;
        }
        @media (min-width: 900px){
          .ak-admin-page{ padding-top: 38px; }
        }
      `}</style>

      <div className="card">
        {/* Centered heading */}
        <h2 className="section-title" style={{ margin: 0, textAlign: "center" }}>
          Admin
        </h2>

        {/* Thin line under heading */}
        <div style={{ borderTop: "1px solid var(--border)", margin: "8px 0 12px" }} />

        {/* Theme button centered under the line */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>
          <button className="btn" onClick={toggleTheme} style={{ minWidth: 160, fontSize: 16 }}>
            {theme === "dark" ? "Switch to Light" : "Switch to Dark"}
          </button>
        </div>

        {/* Admin actions */}
        <div className="card" style={{ marginTop: 12 }}>
          <div
            className="form-grid"
            style={{ gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 12 }}
          >
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/settings")}>
              Company details
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/admin/email")}>
              Email server
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/admin/change-password")}>
              Change password
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/admin/ios-calendar")}>
              iOS Calendar link
            </button>

            {/* Service Reports shortcuts */}
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/service-reports/engineer")}>
              SR: Engineer Checklist
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/service-reports/admin/tasks")}>
              SR: Tasks
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/service-reports/admin/engineers")}>
              SR: Engineers
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/service-reports/admin/reports")}>
              SR: Reports
            </button>

            {/* ✅ These were outside before - now inside the same box */}
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/service-reports/engineer")}>
              Create Service Report
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/service-reports/admin/templates")}>
              Manage Report Templates
            </button>
            <button className="btn" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/email-messages")}>
              Email messages
            </button>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
            <button type="button" className="btn cancel" style={{ minWidth: 160, fontSize: 16 }} onClick={() => navigate("/calendar")}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}